<template>
	<div class="input-view" @click="$emit('click', $event)">
		{{ value }}
	</div>
</template>

<script>
	export default {
		name: 'input-view',
		props: ['value']
	}
</script>

<style lang="scss" scoped>
	.input-view {
		display: inline-block;
		min-width: 70px;
		width: 100%;
		height: 30px;
		line-height: 30px;
		padding: 0 10px 0 10px;
		border: 1px solid #A9A9A9;
	}
</style>